import React, { useState, useRef } from 'react';
import { usePdf } from '@mikecousins/react-pdf';

const PdfToPng = ({pdfUrl}) => {
  const [page, setPage] = useState(1);
  const canvasRef = useRef(null);
  const { pdfDocument } = usePdf({
    file: pdfUrl ? pdfUrl : './asdasd',
    page,
    canvasRef,
  });

  return (
    <div style={{display: 'none'}}>
      {pdfDocument && <canvas id='pdfCanvas' ref={canvasRef} />}
    </div>
  );
};

export default PdfToPng;